import { Record } from "immutable";
import type { RecordOf } from "immutable";
import {
  CHANGE_REDIRECT_PAGE_URL,
  CHANGE_REDIRECT_STATUS_CODE,
  CHANGE_REDIRECT_REDIRECT_URL,
  SET_REDIRECT,
} from "../../helpers/constants";
import type {
  Actions,
  ChangeRedirectPageUrlAction,
  ChangeRedirectStatusCodeAction,
  ChangeRedirectRedirectUrlAction,
  SetRedirectAction,
} from "../../actions/redirectInfo";

export type DefaultStateType = {
  id: string,
  pageUrl: string,
  statusCode: string,
  redirectUrl: string,
}

const defaultState: DefaultStateType = {
  id: "",
  pageUrl: "",
  statusCode: "301",
  redirectUrl: "",
};

export const makeState = Record(defaultState);

export type State = RecordOf<DefaultStateType>;

export const initialState: State = makeState({});

export const initRedirectInfoState = () => initialState;

export type IncomingRedirectInfoState = {
  id: string,
  pageUrl: string,
  redirectUrl: string,
  statusCode: number,
}
// eslint-disable-next-line default-param-last
const redirectInfoReducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case CHANGE_REDIRECT_PAGE_URL: {
      const { pageUrl } = action as ChangeRedirectPageUrlAction;
      return state.set("pageUrl", pageUrl);
    }
    case CHANGE_REDIRECT_STATUS_CODE: {
      const { statusCode } = action as ChangeRedirectStatusCodeAction;
      return state.set("statusCode", statusCode);
    }
    case CHANGE_REDIRECT_REDIRECT_URL: {
      const { redirectUrl } = action as ChangeRedirectRedirectUrlAction;
      return state.set("redirectUrl", redirectUrl);
    }
    case SET_REDIRECT: {
      const { payload } = action as SetRedirectAction;
      const {
        id,
        pageUrl,
        redirectUrl,
        statusCode,
      } = payload;
      return state.withMutations((newState) => {
        newState.set("id", id);
        newState.set("pageUrl", pageUrl);
        newState.set("redirectUrl", redirectUrl);
        newState.set("statusCode", String(statusCode));
      });
    }
    default:
      return state;
  }
};

export default redirectInfoReducer;
